import { color } from "./../../node_modules/@types/d3-color/index.d";
import styled from "styled-components";
import { motion } from "framer-motion";

export const Container = styled.div`
  padding: 2.4rem 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  .simple-measure-box {
    display: flex;
    align-items: center;
    background-color: white;
    padding: 1.6rem;
    border-radius: 1rem;
    box-shadow: 1px 1px 4px 0px #0000004d;
    gap: 2.4rem;
    cursor: pointer;
    .l {
      flex: 1;
      color: #225298;
      display: flex;
      flex-direction: column;
      gap: 1.1rem;
      span {
        font-size: 1.2rem;
        font-weight: 400;
        line-height: 2rem;
      }
      p {
        font-size: 1.4rem;
        font-weight: 700;
        line-height: 2rem;
        letter-spacing: -0.06rem;
      }
    }
    .r {
      display: flex;
      svg {
        width: 2.4rem;
        height: 2.4rem;
        path {
          fill: #225298;
        }
      }
    }
  }
  .deep-measure-box {
    display: flex;
    align-items: center;
    background: #225298;
    padding: 1.6rem;
    border-radius: 1rem;
    box-shadow: 1px 1px 4px 0 #00000040;
    gap: 2.4rem;
    .l {
      flex: 1;
      color: white;
      display: flex;
      flex-direction: column;
      gap: 1.1rem;
      span {
        font-size: 1.2rem;
        font-weight: 400;
        line-height: 2rem;
      }
      p {
        font-size: 1.4rem;
        font-weight: 700;
        line-height: 2rem;
        letter-spacing: -0.06rem;
      }
    }
    .r {
      display: flex;
      svg {
        width: 2.4rem;
        height: 2.4rem;
      }
    }
  }
  .recently-record-box {
    .t {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1.2rem 0.8rem;
      > span {
        font-size: 1.6rem;
        font-weight: 700;
        line-height: 2rem;
        letter-spacing: -0.06rem;
      }
      button {
        padding: 0.4rem;
        font-size: 1.2rem;
        font-weight: 400;
        line-height: 1.6rem;
        outline: none;
        border: none;
        background-color: transparent;
        display: flex;
        gap: 0.4rem;
        align-items: center;
        justify-content: center;
        span {
          display: flex;
        }
      }
    }
    @media screen and (min-width: 785px) {
      max-height: 50rem;
      overflow: scroll;
    }
  }
`;

export const SimpleContainer = styled.div`
  height: 100vh;
  @media screen and (min-width: 785px) {
    width: 37.5rem;
    border: 1px solid #ececec;
    border-radius: 0.5rem;
    margin: 0 auto;
    overflow: hidden;
  }
`;

export const Step = styled(motion.div)`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 5.6rem);
  form {
    height: 100%;
  }
  &.step-one {
    padding-bottom: 8rem;
  }
`;

export const StepWrap = styled.div`
  padding: 2.4rem 1.6rem;
  background-color: #fafafa;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
  overflow: hidden scroll;
  .box {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    .box-item-1 {
      font-size: 1.5rem;
      font-weight: 700;
      line-height: 2rem;
      letter-spacing: -0.06rem;
      white-space: pre-wrap;
    }
    .box-item-2 {
      font-size: 1.3rem;
      font-weight: 400;
      line-height: 2rem;
      display: flex;
      flex-direction: column;
      gap: 0.8rem;
      white-space: pre-wrap;
      .img-box {
        width: 100%;
        img {
          max-width: 100%;
        }
      }
    }
  }
`;

export const FtBtnBox = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 1.6rem 1.6rem 3.7rem;
  background-color: white;
  button {
    width: 100%;
    background-color: #225298;
    color: white;
    border: none;
    outline: none;
    border-radius: 0.5rem;
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 2.4rem;
    padding: 1.6rem;
    &:disabled {
      cursor: default;
      background-color: #cecece;
    }
  }
  @media screen and (min-width: 785px) {
    width: 37.3rem;
    margin: 0 auto;
    overflow: hidden;
    left: auto;
  }
`;

export const SurveyItemBox = styled.div`
  .index-box {
    display: flex;
    gap: 0.5rem;
    justify-content: center;
    align-items: center;
    span {
      font-size: 1.5rem;
      font-weight: 700;
      line-height: 2rem;
    }
  }
  .m {
    padding: 1rem 1.6rem;
    .question-box {
      height: 10rem;
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: pre-wrap;
      font-size: 1.6rem;
      line-height: 2.2rem;
      font-weight: 700;
      text-align: center;
    }
    .img-box {
      display: flex;
      img {
        max-width: 100%;
      }
    }
  }
  .survey-answer-box {
    padding: 1.6rem;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    button {
      box-shadow: 0px 1px 3px 1px #00000026, 0px 1px 2px 0px #0000004d;
      border: none;
      background-color: white;
      border-radius: 1rem;
      padding: 1.2rem 1.4rem;
      font-weight: 700;
      font-size: 1.4rem;
      line-height: 2rem;
      &:active {
        transform: scale(0.96);
      }
    }
  }
`;

export const SurveyAudioItemBox = styled.div`
  .index-box {
    display: flex;
    gap: 0.5rem;
    justify-content: center;
    align-items: center;
    span {
      font-size: 1.5rem;
      font-weight: 700;
      line-height: 2rem;
    }
  }
  .m {
    padding: 1rem 1.6rem;
    .question-box {
      height: 10rem;
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: pre-wrap;
      font-size: 1.6rem;
      line-height: 2.2rem;
      font-weight: 700;
      text-align: center;
    }
    .audio-box {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2rem 0;
      flex-direction: column;
      gap: 0.8rem;
      img {
        max-width: 100%;
      }
      span {
        font-size: 1.2rem;
        font-weight: 700;
      }
    }
  }
  .survey-audio-box {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1.6rem 2rem;
    gap: 1.2rem;
    .box-item {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
    button {
      border: none;
      box-shadow: 0px 1px 3px 1px #00000026, 0px 1px 2px 0px #0000004d;
      border-radius: 2rem;
      padding: 1.3rem;
      width: 100px;
      background-color: white;
      font-weight: 700;
      font-size: 1.6rem;
      line-height: 2.2rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const InspectResultContainer = styled.div`
  height: 100vh;
  @media screen and (min-width: 785px) {
    width: 37.5rem;
    border: 1px solid #ececec;
    border-radius: 0.5rem;
    margin: 0 auto;
    overflow: hidden scrolls;
    height: 100vh;
  }
`;

export const InspectResultBox = styled.div`
  padding: 0 2.4rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  height: calc(100% - 5.6rem);
  padding-bottom: 14rem;
  overflow: hidden scroll;
`;

export const SensitivityResulBox = styled.div`
  padding: 1.6rem 2.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
  .title {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    align-items: center;
    span {
      font-size: 1.2rem;
    }
    h3 {
      font-size: 1.6rem;
    }
  }
  .img-box {
    width: 20rem;
    height: 20rem;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      max-width: 100%;
    }
  }
  .content-box {
    font-size: 1.4rem;
    line-height: 2rem;
  }
`;

export const SensitivityResultSubBox = styled.div`
  p {
    font-size: 1.4rem;
    font-weight: 700;
    padding: 0.8rem 0;
  }
  .measure-box {
    padding: 1.6rem;
    font-size: 1.3rem;
    line-height: 1.6rem;
    background-color: #ececec;
    color: #575757;
    border-radius: 1rem;
  }
`;

export const NoiseResultBox = styled.div`
  p {
    font-size: 1.4rem;
    font-weight: 700;
    padding: 0.8rem 0;
  }
  .noise-box {
    padding: 1.6rem;
    font-size: 1.3rem;
    line-height: 1.6rem;
    background-color: #ececec;
    color: #575757;
    border-radius: 1rem;
  }
`;

export const InspectShareBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  .title {
    padding: 1.2rem;
    font-size: 1.4rem;
    font-weight: 700;
  }
  .btn-box {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    align-items: center;
    justify-content: center;
    button {
      font-size: 1.3rem;
      font-weight: 500;
      line-height: 2rem;
      letter-spacing: -0.06rem;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.4rem;
      width: 100%;
      padding: 1rem;
      border: 1px solid #ececec;
      border-radius: 0.5rem;
      background-color: white;
      .icon-box {
        width: 1.6rem;
        display: flex;
        svg {
          max-width: 100%;
        }
        img {
          max-width: 100%;
        }
      }
    }
  }
`;

export const InspectHomeRecentlyRecordWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  .itme-wrapper {
    display: flex;
    gap: 0.4rem;
    flex-direction: column;
    border-bottom: 1px solid #cecece;
    padding: 1.6rem 0.8rem;
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      p {
        min-width: 19.7rem;
        font-size: 1.4rem;
        line-height: 1.8rem;
        font-weight: 700;
      }
      span {
        font-size: 1.2rem;
        line-height: 1.6rem;
        font-weight: 700;
        display: flex;
        padding: 0.3rem 0.7rem;
        border: 1px solid #225298;
        border-radius: 100px;
        color: #225298;
      }
    }
    .contents-box {
      display: flex;
      gap: 0.8rem;
      align-items: center;
      .img-box {
        width: 5rem;
        height: 5rem;
        border-radius: 0.5rem;
        img {
          max-width: 100%;
        }
      }
      .result-type {
        display: flex;
        flex-direction: column;
        gap: 0.4rem;
        p {
          font-size: 1.2rem;
          line-height: 1.6rem;
        }
        h4 {
          font-size: 1.4rem;
          font-weight: 700;
          line-height: 1.8rem;
          letter-spacing: -0.06rem;
        }
      }
    }
  }
`;

export const NoData = styled.div`
  padding: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    font-size: 1.4rem;
    line-height: 2rem;
    padding: 1.6rem;
  }
`;

export const InspectResultListWrapper = styled.div`
  height: calc(100vh - 5.6rem);
`;

export const InspectListItemsWrapper = styled.div`
  padding: 1.6rem;
  height: 100%;
  overflow: hidden scroll;
  .itme-wrapper {
    display: flex;
    gap: 0.4rem;
    flex-direction: column;
    border-bottom: 1px solid #cecece;
    padding: 1.6rem 0.8rem;
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      p {
        min-width: 19.7rem;
        font-size: 1.4rem;
        line-height: 1.8rem;
        font-weight: 700;
      }
      span {
        font-size: 1.2rem;
        line-height: 1.6rem;
        font-weight: 700;
        display: flex;
        padding: 0.3rem 0.7rem;
        border: 1px solid #225298;
        border-radius: 100px;
        color: #225298;
      }
    }
    .contents-box {
      display: flex;
      gap: 0.8rem;
      align-items: center;
      .img-box {
        width: 5rem;
        height: 5rem;
        border-radius: 0.5rem;
        img {
          max-width: 100%;
        }
      }
      .result-type {
        display: flex;
        flex-direction: column;
        gap: 0.4rem;
        p {
          font-size: 1.2rem;
          line-height: 1.6rem;
        }
        h4 {
          font-size: 1.4rem;
          font-weight: 700;
          line-height: 1.8rem;
          letter-spacing: -0.06rem;
        }
      }
    }
  }
`;
